module.exports = __webpack_public_path__ + "img/footer-new.7fd11d56.jpg";